import React from "react";
import styled from "styled-components";
import JS30Card from "./JS30Card";
import { useLanguage } from "../../contexts/LanguageContext";
import {
  getJS30Translation,
  getJS30ChallengeDetail,
} from "../../translations/miniProjectsAndJS30";
import { js30Challenges } from "../../data/js30Challenges";

function Js30() {
  const { language } = useLanguage();
  const colors = [
    "#00fffc",
    "#fc00ff",
    "#1dff00",
    "#f6ff00",
    "#00f6ff",
    "#ee00ff",
    "#ffbaba",
    "#b37aff",
  ];
  function getRandomColor() {
    return colors[Math.floor(Math.random() * colors.length)];
  }

  return (
    <CardBody>
      <ItemText>
        <h1>{getJS30Translation(language, "title")}</h1>
        <p>{getJS30Translation(language, "description")}</p>
      </ItemText>
      <CardContainer>
        {js30Challenges.map((challenge) => {
          const title = getJS30ChallengeDetail(
            language,
            challenge.key,
            "title"
          );
          const description = getJS30ChallengeDetail(
            language,
            challenge.key,
            "description"
          );
          const faceTitle = challenge.key.toUpperCase();

          return (
            <JS30Card
              key={challenge.key}
              title={title}
              description={description}
              githubLink={challenge.githubLink}
              websiteLink={challenge.websiteLink}
              faceTitle={faceTitle}
              textColor={getRandomColor()}
            />
          );
        })}
      </CardContainer>
    </CardBody>
  );
}

export default Js30;

const CardBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: "Righteous", cursive !important;
  min-height: 100vh;
`;

const CardContainer = styled.div`
  max-width: 90vw;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 1px;
  margin: 0 auto;
  padding: 30px 0;
`;

const ItemText = styled.div`
  width: 50vw;
  margin-top: 12vh;
  justify-content: center;
  text-align: center;
  color: black;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 80vw;
  }

  h1 {
    margin-top: -7px;
    @media (max-width: 768px) {
      font-size: 24px;
      margin-top: -4px;
    }
  }

  p {
    font-size: 16px;
  }
`;
